import { __rest, __assign } from 'tslib';
import React, { forwardRef, useState, useCallback } from 'react';
import cn from 'classnames';
import { IconButton } from '../../icon-button/esm';
import { Input } from '../../input/esm';
import { EyeMIcon } from '@alfalab/icons-glyph/EyeMIcon';
import { EyeOffMIcon } from '@alfalab/icons-glyph/EyeOffMIcon';

var styles = {"eye":"password-input__eye_1dv7m","size-72":"password-input__size-72_1dv7m","addons":"password-input__addons_1dv7m"};
require('./index.css');

var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-48',
    m: 'size-56',
    l: 'size-64',
    xl: 'size-72',
    48: 'size-48',
    56: 'size-56',
    64: 'size-64',
    72: 'size-72',
};
var PasswordInput = forwardRef(function (_a, ref) {
    var onPasswordVisibleChange = _a.onPasswordVisibleChange, passwordVisible = _a.passwordVisible, disabled = _a.disabled, colors = _a.colors, rightAddons = _a.rightAddons, _b = _a.size, size = _b === void 0 ? 48 : _b, className = _a.className, restProps = __rest(_a, ["onPasswordVisibleChange", "passwordVisible", "disabled", "colors", "rightAddons", "size", "className"]);
    var uncontrolled = passwordVisible === undefined;
    var _c = useState(uncontrolled ? false : passwordVisible), statePasswordVisible = _c[0], setStatePasswordVisible = _c[1];
    var handleButtonClick = useCallback(function () {
        if (onPasswordVisibleChange) {
            onPasswordVisibleChange(!passwordVisible);
        }
        if (uncontrolled) {
            setStatePasswordVisible(function (visible) { return !visible; });
        }
    }, [passwordVisible, uncontrolled, onPasswordVisibleChange]);
    var isPasswordVisible = uncontrolled ? statePasswordVisible : passwordVisible;
    return (React.createElement(Input, __assign({}, restProps, { disabled: disabled, type: isPasswordVisible ? 'text' : 'password', size: size, ref: ref, colors: colors, className: cn(className, styles[SIZE_TO_CLASSNAME_MAP[size]]), rightAddons: React.createElement(React.Fragment, null,
            rightAddons,
            React.createElement(IconButton, { className: styles.eye, colors: colors, view: 'secondary', size: 's', icon: isPasswordVisible ? EyeMIcon : EyeOffMIcon, onClick: handleButtonClick, disabled: disabled, title: isPasswordVisible
                    ? 'Скрыть введённые цифры'
                    : 'Показать введённые цифры' })), addonsClassName: styles.addons, inputClassName: styles.input })));
});
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
